import React from "react";
import "../styles/Preloader.scss";
import logo from "../assets/logo2.png";

interface PreloaderProps {
  fadeOut: boolean;
}

const Preloader: React.FC<PreloaderProps> = ({ fadeOut }) => {
  return (
    <div className={`preloader ${fadeOut ? "fade-out" : ""}`}>
      <img src={logo} alt="Loading..." className="preloader-logo" />
    </div>
  );
};

export default Preloader;
